import type * as React from 'react';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import passwordResetRequested, {
	type PasswordResetRequestedAction,
} from '@Application/Security/PasswordResets/Actions/passwordResetRequested';
import passwordResetRequestFailed, {
	type PasswordResetRequestFailedAction,
} from '@Application/Security/PasswordResets/Actions/passwordResetRequestFailed';
import type RequestPasswordReset from '@Application/Security/PasswordResets/Commands/RequestPasswordReset';
import FALLBACK_MESSAGES from '@Application/Security/TokenJourney/FALLBACK_MESSAGES';
import resolveFailureReason from '@Application/Security/TokenJourney/resolveFailureReason';
import parameters from '../../../parameters';

type Actions = PasswordResetRequestedAction | PasswordResetRequestFailedAction;

export default (command: RequestPasswordReset) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			// The route always answers 204: reading the response would throw on the nominal path.
			await post<void>(`${parameters.api.host}/api/password-resets`, command.toJSON());

			const action = passwordResetRequested();
			dispatch(action);
			return action;
		} catch (error) {
			const extractedMessages = extractMessages(error);
			const reason = resolveFailureReason(error);
			const message = extractedMessages?.message ?? FALLBACK_MESSAGES.passwordResetRequestFailed;
			const action = passwordResetRequestFailed(extractedMessages, reason, message);
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
